module.exports = __webpack_public_path__ + "static/media/Fresh_Pack_Hazel3_Side.93c874b7.png";